<div class="row g-0 careers-nav-card">
  <!-- Close button -->
  <button 
    type="button" 
    class="btn-close position-absolute m-3" 
    aria-label="Close"
    (click)="closeCard()">
  </button>
 
  <div class="col-md-4 p-4 careers-nav-bg d-flex flex-column justify-content-start">
    <h2 class="text-orange fs-4 fw-bold mb-3">Build The Future You Believe In</h2>
    <p class="text-gray small mb-0">
      We are constantly on the lookout for amazing talents. 
      You can be a part of our work family too. We make it 
      simple for you to join us.
    </p>
  </div>
  
  <div class="col-md-8 p-4 bg-white">
    <h3>Careers</h3>
    <ul class="list-unstyled mb-0">
      <li>
        <a href="javascript:void(0)" class="dropdown-item"
           (click)="navigateTo('careers/career-at-kalpita')">Careers at Kalpita</a>
      </li>
      <li>
        <a href="javascript:void(0)" class="dropdown-item"
           (click)="navigateTo('careers/kalpita-open-positions')">Open Positions</a>
      </li>
    </ul>
  </div>
</div>